import { ContentLanguage } from 'types/general';
import {
  surveyAnswerTypes,
  surveyChoiceAnswerFormats,
  SurveyType,
} from 'store/surveys';
import { Values } from './survey-content.types';

export const createEmptyQuestion = (
  language: Uppercase<ContentLanguage>,
): Values['questions'][number] => ({
  type: surveyAnswerTypes[0],
  subType: '',
  choiceAnswerFormat: surveyChoiceAnswerFormats[0],
  isRequired: true,
  conditionalJump: { isEnabled: false, rules: [] },
  withImage: false,
  withDescription: false,
  withAttachments: false,
  withVideo: false,
  imageId: null,
  translations: [
    {
      language,
      text: '',
      description: '',
      attachments: [],
      videos: [],
    },
  ],
  answers: [
    {
      imageId: null,
      isCorrect: false,
      translations: [{ language, text: '' }],
    },
  ],
});

export const getInitialValues = (
  defaultLanguage: Uppercase<ContentLanguage>,
  surveyType?: SurveyType,
): Values => ({
  languages: [defaultLanguage],
  translations: [
    {
      language: defaultLanguage,
      title: '',
      description: '',
      imageId: '',
      attachments: [],
      videos: [],
    },
  ],
  questions:
    surveyType === 'training' ? [] : [createEmptyQuestion(defaultLanguage)],
  settings: {
    withDescription: false,
    withImage: false,
    withAttachments: false,
    withVideo: false,
  },
  ui: {
    selectedLanguage: defaultLanguage,
    selectedQuestionIndex: NaN,
    isSameImage: false,
  },
});
